var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-spinner--wrapper",class:{ 'r-spinner--wrapper--harf': _vm.harfSize }},[_c('circles-to-rhombuses-spinner',{attrs:{"animation-duration":800,"circles-num":3,"circle-size":15,"color":"#e87352"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }